export const TABLE_NAMESPACE = 'ddt';
